import { render, staticRenderFns } from "./AppDashboardEmployees.vue?vue&type=template&id=61f39554&scoped=true&"
import script from "./AppDashboardEmployees.vue?vue&type=script&lang=js&"
export * from "./AppDashboardEmployees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f39554",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VScrollXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VDataTable,VIcon,VScrollXTransition})
